import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Icon, Link } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { LanguageSwitcher } from "@/common/components";
import { useNavigateSearch } from "@/premium/hooks";
import { EnrollmentContext } from "@/state";
import { enableComparePlansPage } from "@/utils/featureFlags";

import "./DesktopMenuBar.scss";

const translationPath = "HEADER_AND_FOOTER";

export const DesktopMenuBar = () => {
  const navigate = useNavigateSearch();
  const [state] = useContext(EnrollmentContext);
  const theme = state.experienceData?.theme;
  const urlLocation = window.location;
  const searchParams = new URLSearchParams(urlLocation.search);
  const clientName = searchParams.get("client");
  const menuItems = state.experienceData?.menu_items;
  const { t: translate } = useTranslation();

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <nav>
      <Shelf className="bar" spacing="large">
        <img
          onClick={handleHomeClick}
          style={{ cursor: "pointer" }}
          data-testid="img-logo"
          height={30}
          src={theme?.logo_desktop}
          alt="Client Logo"
        />
        <Link className="menu-bar-link" to={{ pathname: "/plans", search: `client=${clientName}` }}>
          {translate(`${translationPath}.plans`)}
        </Link>
        {enableComparePlansPage() && (
          <Link className="menu-bar-link" to={{ pathname: "/compare-plans", search: `client=${clientName}` }}>
            {translate(`${translationPath}.comparePlans`)}
          </Link>
        )}
        {menuItems
          .sort((a, b) => a.display_order - b.display_order)
          .map((item) => (
            <Shelf key={item.id}>
              <Link key={item.id} className="menu-bar-link" to={item.link_url}>
                {item.link_name}
              </Link>
              <Icon name="link-out" />
            </Shelf>
          ))}
        <Shelf.Spacer />
        <LanguageSwitcher />
      </Shelf>
    </nav>
  );
};
